$(document).ready(function(){
  
  //GLOBAL Var	
  var lang = $('html').attr('lang');
  var current_artist = $('body').data('current-shop');
  const shopUrl = window.location.origin;

  //Patch car sinon, lorsque le panier est vide au chargement de la page, le compteur ne s'affiche pas à l'ajout du premier produit (depuis section "Featured product V2")
  $('.add-to-cart-btn').on('click', function(){
    $('#headerContainer #CartCount').removeClass('hidden');
  });

  //Dans les sections Featured Product V2, cela permet le click sur les boutons du slider sans effectuer la redirection vers la page produit (quand link actif)
  $('.product-link .splide__arrow').on('click', function(e) {
    // Empêcher la redirection par défaut de la balise <a>
    e.preventDefault();
  });
  
  //Ajoute les items Property pour le Standalone Product + Chaque produit des combo Mix & Match
  document.addEventListener('bundler:bundle_widget_created', function(e) {
      document.querySelectorAll('.bndlr-product').forEach(function(el, index) {
          el.innerHTML += '<input name="properties[_Shop]" type="hidden" value="'+current_artist+'" />';
      });
  });

  // This event will be fired whenever a customer adds a product to Mix & Match bundle
  document.addEventListener('bundler:mixnmatch:product_added', function(e) {
    document.querySelectorAll('.bndlr-mnm-selected-products .bndlr-product').forEach(function(el, index) {
        el.innerHTML += '<input name="properties[_Shop]" type="hidden" value="'+current_artist+'" />';
      });
  });
  // e.detail will contain the following JSON object:
  // {
  // 		product_id	: productId, // ID of the product added to the bundle 
  //		variant_id	: variantId, // ID of the variant added to the bundle 
  //		quantity	: quantity,	 // Quantity of the product added to the bundle
  // }

  
  // Fonction pour initialiser la logique de scroll
  function initScrollFunction() {
    if ($('#filter-mob-button-wrap').length > 0) {
      var $filterMarkPosition = $('#filter-mob-button-wrap-mark');
      var $filterWrapper = $('#filter-mob-button-wrap');
      var $footer = $('.section-site-footer');
      var offsetTop = $filterMarkPosition.offset().top - 140;

      $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();
        var footerOffsetTop = $footer.offset().top;
        var windowHeight = $(window).height();

        if (scrollTop >= offsetTop && (scrollTop + windowHeight) < footerOffsetTop) {
          $filterWrapper.addClass('fixed');
        } else {
          $filterWrapper.removeClass('fixed');
        }
      });
    }
  }

  // Observer pour surveiller les changements dans #facets-filterable
  const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        console.log('Mutation observée');
        // Vérifie si #filter-mob-button-wrap est dans le DOM après une mise à jour AJAX
        if ($('#filter-mob-button-wrap').length > 0) {
          initScrollFunction(); // Relance la fonction du scroll
        }
      }
    });
  });

  // Cibler l'élément parent qui subit des changements
  const targetNode = document.getElementById('facets-filterable');
  const config = { childList: true, subtree: true };

  // Démarrer l'observation sur #facets-filterable pour détecter les ajouts d'éléments
  if ($('#filter-mob-button-wrap').length > 0) {
    observer.observe(targetNode, config);
  }

  // Initialisation immédiate si l'élément est déjà présent lors du premier chargement
  initScrollFunction();
  
  

  //On rejoue la fonction à chaque changement de variante select
    $('.template-product .product-variant-picker-block .single-option-selector').change(function() {
      updateQuoteBlock();
     });

  //On met à jour les champs de détails
    function updateQuoteBlock() {  
      const $variant_items_block = $('#MainContent').find('.block-quote.dynamic');

      //On décale un petit peu la récup d'info sinon ne laisse pas le temps au select de se mettre à jour
      setTimeout(function() {

        //On récupère l'id variant sélectionné
        const variant_id_selected = $('form select[x-ref="singleVariantSelector"]').val().toString();
        
        //On met à jour le bloc d'infos
        $variant_items_block.removeClass('visible');
        
        $variant_items_block.each(function(){
          let data_variant_id = $(this).data('variant-id').toString();
          console.log(variant_id_selected +' and '+ data_variant_id);
          if(variant_id_selected == data_variant_id){
            console.log('found');
            $(this).addClass('visible');
          }
          
        }); 
      }, 100);
  }

  //Ajoute le produit dynamiquement au panier dans le menu déroulant
  // Old value in onchange attribute : if (this.value.startsWith('/')) {window.location = this.value} 
  
  // Fonction pour ajouter un produit au panier depuis un ID de variante
  function addProductToCart(productId, $dynamic_message) {
    //Spruce.store('drawer').cartDrawerOpen = true; // Ouvre le drawer immédiatement

    addItem(productId, { quantity: 1 })
      .then(() => {
      //On affiche le message de succés
      displayMessage('success', $dynamic_message);

      //On cache le message d'ajout au panier après quelques secondes
      setTimeout(function() {
        $dynamic_message.find('.product-added').addClass('hidden');
      }, 3000);
    })
    .catch((error) => {
      console.error("Erreur lors de l'ajout au panier:", error);
      displayMessage('error', $dynamic_message);
    });
  }

  // Fonction pour afficher un message d'erreur
  function displayMessage(type, $dynamic_message) {
    $dynamic_message.children().addClass('hidden');
    
    if (type == 'success') {
      $dynamic_message.find('.product-added').removeClass('hidden');
    } else if (type == 'unavailable') {
      $dynamic_message.find('.product-unavailable').removeClass('hidden');
    } else {
      $dynamic_message.find('.error').removeClass('hidden');
    }
  }
  
  // Gestion de la sélection dans le menu déroulant
  $('.product-dropdown').each(function(){
    $(this).find('select').on('change', function() {
      const $dynamic_message = $(this).parents('.product-dropdown').prev();
      const selectedProductURL = $(this).val(); // URL de produit sélectionné
  
      //Ne doit pas se déclencher si c'est la valeur par défaukt qui est cochée.
      if (!selectedProductURL || selectedProductURL == 'default') return;
  
      // Récupération des informations de variante
      fetch(`${shopUrl}${selectedProductURL}.js`)
        .then(response => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then(data => {
          const availableVariant = data.variants.find(variant => variant.available);
          if (availableVariant) {
            addProductToCart(availableVariant.id, $dynamic_message);
          } else {
            displayMessage('unavailable', $dynamic_message);
          }
        })
        .catch(error => {
          console.log("Erreur lors de la récupération du produit :", error);
          displayMessage('error', $dynamic_message);
        });
    });
    });  
  
  //Supprime les virgules en fin de liste des Collections List Formats Grouped
  /*
  if ( $('ul.variant-list').length != -1 ) {
    $('ul.variant-list').each(function(){
      var length_ul = $(this).find('li').length;
      $(this).find('li').each(function(index_li){
        if(index_li == length_ul - 1){
          if ($(this).find('span.comma')) {
            $(this).addClass('added');
            $(this).find('span.comma').remove();
          }
        }
      });
    });
  }
  */
  
  //Gère les boutons read more des RichText sections
  if ( $('.toggle-rich-text').length != -1 ) {
    $('.toggle-rich-text').each(function(){
        
      let $read_more = $(this).find('#read-more')
      let $read_less = $(this).find('#read-less');
      let $truncated_description = $(this).find('#truncated-richtext');
      let $full_description = $(this).find('#full-richtext');
      
      $read_more.on('click', showHideDescription);
      $read_less.on('click', showHideDescription);
      
      function showHideDescription($this){
        let ID = $(this).attr('id');
        if(ID === "read-more"){
          $truncated_description.css('display','none');
          $full_description.css('display','block');
        }else {
          $truncated_description.css('display','block');
          $full_description.css('display','none');
        }
      }
    });
  }
  
  //Initialise le carousel de la section qui affiche les albums en infinie
  $('.init-carousel').each(function(){
    var $carousel_wrap = $(this);
    $(this).slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="block transform rotate-180 w-5 h-5 lg:w-8 lg:h-8"><svg aria-hidden="true" focusable="false" role="presentation" class="icon fill-current icon-chevron-right" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M39.336 32L18 10.663l2.666-2.666L44.66 31.992l-.008.007.008.008L20.667 56 18 53.335l21.335-21.336z"></path></svg></span></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="block w-5 h-5 lg:w-8 lg:h-8"><svg aria-hidden="true" focusable="false" role="presentation" class="icon fill-current icon-chevron-right" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M39.336 32L18 10.663l2.666-2.666L44.66 31.992l-.008.007.008.008L20.667 56 18 53.335l21.335-21.336z"></path></svg></span></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $(this).find('.slick-arrow').each(function(){
      $(this).on('click', function(){
      });
    });
  });

  
  $('.js-add-slide').on('click', function() {
  slideIndex++;
  $('.add-remove').slick('slickAdd','<div><h3>' + slideIndex + '</h3></div>');
});
  
  //Update la value du champ property pour savoir sur quelle boutique a été acheté le produit
  //On utilise ensuite une application qui ajoutera un tag à la commande si la line-item détient telle ou telle property value
  //https://apps.shopify.com/ordertagger
  if ($('.line-item-property__field #shop').length > 0) {
    var current_artist = $('body').data('current-shop');
    $('.line-item-property__field').each(function(){
      $(this).find('#shop').val(current_artist);
    })
  }
    
  //Détecte le contenu de l'URL et croise avec la liste des artistes pour savoir
  //si on doit afficher le header Artiste ou Secret City
  if ($('.dynamic-hf-js').length > 0) {
    var full_url = $(location).attr('href');
    var all_artists_shop = $('body').data('all-artists-shop');
    var array_all_artists_shop = all_artists_shop.split(',');
    var current_shop = 'secret-city';
    
    $.each(array_all_artists_shop, function(index,value) {
      
      if(full_url.indexOf(value) > 0) {
        //Si on est sur une page directe du produit (Secret City) mais qui détient quand même le nom de l'artiste dans l'URL
        if (full_url.indexOf('/products/') != -1 && full_url.indexOf('/collections/') == -1 ) {
          current_shop = current_shop;

        //Sinon on est sur une page Artiste
        } else {
          current_shop = value;
          console.log('Boutique Artiste : '+current_shop);
          return false;
        }

        //On update la data du body
        $('body').attr('data-current-shop',current_shop);

        //On update le nom du menu sidebar
        var currentArtist = current_shop.replace('-',' ');
        $('#title_current_artist').text(currentArtist);
        
      }
    });

    //Le Header et Footer dynamic JS est uniquement utilisé sur les pages 404 (Liquid ne détecte pas l'URL dans ce template)
    if ($('body').hasClass('template-404')) {
      if (current_shop != 'secret-city' ) {
        displayArtistHF(current_shop);
      } else {
        console.log('nous sommes sur la boutique de '+current_shop);
        displaySecretCityHF(current_shop);
      }
    }

    function displayArtistHF(current_shop) {
      //On change le favicon
      switchFaviconArtist(current_shop);
      
      //On supprime les sections inutiles
      $('#shopify-section-header').remove();
      $('#shopify-section-footer').remove();
      $('#shopify-section-sidebar').remove();

      //On supprime les header Artistes inutiles
      $('#shopify-section-headerArtist').find('.wrap-artist-header:not(*[data-artist="'+current_shop+'"])').remove();
      $('#shopify-section-footerArtist').find('footer:not(*[data-artist="'+current_shop+'"])').remove();
      
      //Puis on dévoile le Header et Footer de l'artiste concerné grâce à l'opacité (on a caché au préalable en CSS) 
      $('#shopify-section-headerArtist').find('*[data-artist="'+current_shop+'"]').css('opacity','1');
      $('#shopify-section-footerArtist').find('*[data-artist="'+current_shop+'"]').css('opacity','1');
      
      
    }

    function displaySecretCityHF(current_shop) {
      $('#shopify-section-headerArtist').remove();
      $('#shopify-section-footerArtist').remove();
      $('#shopify-section-sidebarArtist').remove();
      $('#shopify-section-header > header').css('opacity','1');
      $('#shopify-section-footer > footer').css('opacity','1');
    }

    function switchFaviconArtist(current_shop){
      //On récupère les data générées en liquid dans le body
       var all_favicon_artists = $('body').data('all-favicon-artists'); 
       var array_all_favicon_artists = all_favicon_artists.split(',');

        //On crawl à travers les url favicon pour voir si on trouve celle de l'artiste
         $.each(array_all_favicon_artists, function(index,favicon_artist) {

          //Si on la trouve
          if(favicon_artist.indexOf(current_shop) != 1) {
            var array_url_favicon = favicon_artist.split(':')
            var url_favicon = array_url_favicon[1]
            
            //On update l'url du link favicon de la boutique
            $('#favicon').attr('href',url_favicon)
          }
        });
    }
  }

  
  //On génère l'affichage Masonry pour les blocs "Spécifications" en page produit
  $('body.template-product .specifications-list.wrapper').masonry({
    // options
    itemSelector: 'body.template-product .specifications-list.wrapper > .specif',
    columnWidth: 'body.template-product .specifications-list.wrapper > .grid-sizer',
    percentPosition: true,
    gutter: 'body.template-product .specifications-list.wrapper > .gutter-sizer',
    horizontalOrder: true
  });
  

  //Clean les filtres en pages Collections list
  if ($("#Facet-Filters-Form").length != 0) {
    $('#Facet-Filters-Form > div > div > div').each(function(index){
      $(this).find('ul > li').each(function(){
        
        //On supprime le tag "preorder"
        var label_text = $(this).find('span.mr-1').text();
        if (label_text == 'preorder' || label_text == 'Combo' || label_text == 'Sold Only in Canada' || label_text == 'Music') {
          $(this).remove();
        }
      });

      //On met dans l'ordre les albums
      if (index == 1) {
        $(this).find('ul > li:nth-child(1)').insertAfter($(this).find('ul > li:nth-child(2)').first());
      }
    });
  }

  //Ne fonctionne pas sur la page 404 car data-current-shop est ajouté en JS
  function updateLinkPoliciesCookieBar($policies_link) {	

    }

  //Renvoie le lien vers les politiques de confidentialité Artiste au lieu de SC
  //Au click sur le lien des politiques de confidentialité, on update si on est en page artiste
  $(document).on('click','a',function(){
    var current_artist = $('body').data('current-shop');
    if(current_artist != 'secret-city') {
      if ($(this).hasClass('isense-cc-link')) {
        var sc_policies_link = $(this).attr('href');
        if (sc_policies_link.indexOf(current_artist) == -1) { 
          var last_part_url = current_artist + '-privacy-policy';
          var new_policies_link = sc_policies_link.replace('/policies/', '/pages/').replace('privacy-policy',last_part_url);
          $(this).attr('href',new_policies_link);
        }
      }
    }
  });
  
  //On joue la fonction les 5 premières secondes, le temps que l'Ajax charge le contenu
  /*
    updateLinkPoliciesCookieBar();
  	
  	const myInterval = setInterval(updateLinkPoliciesCookieBar, 500);
  
    function myStopFunction() {
      clearInterval(myInterval);
    }
  
    setTimeout(function() { 
          myStopFunction();
    }, 5000);
  */


/***************************************************************************/
/*****  Fonction UTILES  ****/
/***************************************************************************/
//Ces fonction sont récupérées de theme.js car c'est theme.min.js qui est chargée dans le site mais les fonctions ne sont pas visibles/utilisables.
                  
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;'
        }
      })
    );
  }
  
  function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  
  function cartAdd(id, quantity, properties) {
    var config = getDefaultRequestConfig();
  
    config.method = 'POST';
    config.body = JSON.stringify({
      id: id,
      quantity: quantity,
      properties: properties
    });
  
    return fetchJSON('/cart/add.js', config);
  }

  function addItem(id, options) {
    options = options || {};
    validate_id(id);
    return cartAdd(id, options.quantity, options.properties);
  }

  function validate_id(id) {
    if (typeof id !== 'number' || isNaN(id)) {
      throw new TypeError('Theme Cart: Variant ID must be a number');
    }
  }

  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
  
    config.method = 'POST';
    config.body = JSON.stringify(body);
  
    return fetchJSON('/cart/update.js', config);
  }
    
  
});
